import { useTranslation } from "react-i18next";
import { Loader } from "@entur/loader";
import type { QueryClient } from "@tanstack/react-query";
import { createBrowserHistory, createRouter } from "@tanstack/react-router";

import { routeTree } from "@app/routeTree.gen.ts";
import { ErrorMessage } from "@components/ErrorMessage.tsx";
import { NotFound } from "@components/NotFound.tsx";
import config from "@/config.ts";

function PendingSpinner() {
  const { t } = useTranslation();
  return <Loader>{t("common.loading")}</Loader>;
}

const history = createBrowserHistory();

export const createAppRouter = (queryClient: QueryClient) =>
  createRouter({
    routeTree,
    history,
    basepath: config.isStandalone ? "/" : "/automat-ops",
    context: {
      queryClient
    },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultPendingComponent: PendingSpinner,
    defaultErrorComponent: ({ reset }: { reset: () => void }) => <ErrorMessage retry={reset} />,
    defaultNotFoundComponent: () => <NotFound />
  });

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
  interface StaticDataRouteOption {
    breadcrumb?: string;
  }
}
